var map = {
	"./13分屏.png": "6335",
	"./16分屏.png": "d8df",
	"./1分屏.png": "2fb1",
	"./25分屏.png": "ab2f",
	"./4分屏.png": "c4c1",
	"./6分屏.png": "7375",
	"./9分屏.png": "5e4a",
	"./九分屏.png": "0754"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ab2e";